require([
    "formValidator",
    "loadCss",
    "eventLoggerPwa",
    "saveToFavorites",
    "routes",
    "ajaxHelper",
    "i18n!nls/res",
    'loadMap',
    "appNexus",
    "globalCtaHandler",
    "recommendedModalHandler",
], function (formValidator, loadCss, EventLogger, saveToFavorites, routes, ajaxHelper, language, loadMap) {
    "use strict";

    var logger = new EventLogger();
    var logParams = JSON.parse(document.getElementById("LogInformation").value);
    var askQuestionFooter = document.getElementById("nhs_AskBuilderAQuestion");

    if (askQuestionFooter) {
        askQuestionFooter.parentNode.removeChild(askQuestionFooter);
    }

    (function () {
      var configuration = {
        mapElement: document.getElementById("nhs_CommunityMap"),
        mapContainer: document.getElementById("nhs_CommunityMapContainer"),
        askQuestionToBuilderBtn: document.getElementById("nhs_AskBuilderAQuestion"),
        drivingDirectionsContainer: document.getElementById("nhs_DrivingDirections"),
        drivingDirectionsMapButton: document.getElementById("nhs_FullMapGetDirections"),
        currentLocationBtn: document.getElementById("nhs_CurrentLocationMap"),
        openNearByBtn: document.getElementById("nhs_OpenNearby"),
        nearByPanel: document.getElementById("nearByMap-Container"),
        cancelNearByBtn: document.getElementById("cancel_NearByMap"),
        resetNearByBtn: document.getElementById("reset_NearByPanel"),
        staticMapContainer: document.getElementById("nhs_StaticMapContainer"),
        nearByContainer: document.getElementById("nearByMap-Container"),
        closeMap: document.getElementById("nhs_DetailCloseMap"),
        applyNearByBtn: document.getElementById("apply_NearByBtn"),
        nearByCardContainer: document.getElementById("nearByCardContainer"),
        nearByOptions: document.querySelectorAll("#nearByMap-Container .nhs_NearbyOptions li input"),
        logger: logger,
        logParams: logParams
      };

      loadMap.init(configuration);

    })();

    document.getElementById("nhs_Footer").addClass("nhs_FooterDetails");
    saveToFavorites.init();

    (function () {
        var saveToFavoriteButtons = document.getElementsByClassName("nhs_UnSavedListing");
        var phoneNumberButton = document.getElementById("nhs_ContactPhone");
        var phoneNumberModal = document.getElementById("nhs_ModalPhone");
        var phoneNumberOnPage = document.getElementById("nhs_OnPagePhone");
        var drivingDirectionPhoneNumber = document.getElementById("nhs_DrivindDirectionPhone");
        var builderWebsite = document.getElementById("nhs_BuilderWebsite");
        var logCommunityDetail = function () {
            // Logs the Page View (CDPL) event.
            var options = {
                async: true,
                builderId: document.getElementById("BuilderId") ? parseInt(document.getElementById("BuilderId").value) : 0,
                communityId: document.getElementById("CommunityId") ? parseInt(document.getElementById("CommunityId").value) : 0,
                marketId: document.getElementById("MarketId") ? parseInt(document.getElementById("MarketId").value) : 0
            };

            if (document.getElementById("IsMpc") && document.getElementById("IsMpc").value === "true") {
                setTimeout(function () { logger.logEventWithParameters("PageView", options); }, 0);
            } else {
                setTimeout(function () { logger.logEventWithParameters("CDPL", options); }, 0);
            }
        };

        if (saveToFavoriteButtons) {
            for (var elementIndex = 0; elementIndex < saveToFavoriteButtons.length; elementIndex += 1) {
                saveToFavoriteButtons[elementIndex].addEventToElement("click", function () { logger.logEventWithParameters("CDSTC", logParams); });
            }
        }

        if (phoneNumberButton) {
            phoneNumberButton.addEventToElement("click", function () {
                if (logParams.isCallTrackingNumber === "true" || logParams.isCallTrackingNumber === true) {
                    logger.logEventWithParameters("TDVMobileCall", logParams);
                } else {
                    logger.logEventWithParameters("PhoneClick", logParams);
                }
            });
        }


        if (drivingDirectionPhoneNumber) {
            drivingDirectionPhoneNumber.addEventToElement("click", function () {
                if (logParams.isCallTrackingNumber === "true" || logParams.isCallTrackingNumber === true) {
                    logger.logEventWithParameters("TDVMobileCall", logParams);
                } else {
                    logger.logEventWithParameters("PhoneClick", logParams);
                }
            });
        }

        if (phoneNumberModal) {
            phoneNumberModal.addEventToElement("click", function () {
                if (logParams.isCallTrackingNumber === "true" || logParams.isCallTrackingNumber === true) {
                    logger.logEventWithParameters("TDVMobileCall", logParams);
                } else {
                    logger.logEventWithParameters("PhoneClick", logParams);
                }
            });
        }

        if (phoneNumberOnPage) {
            phoneNumberOnPage.addEventToElement("click", function () {
                if (logParams.isCallTrackingNumber === "true" || logParams.isCallTrackingNumber === true) {
                    logger.logEventWithParameters("TDVMobileCall", logParams);
                } else {
                    logger.logEventWithParameters("PhoneClick", logParams);
                }
            });
        }

        if (builderWebsite) {
            var cookieDate = new Date();
            cookieDate.setTime(cookieDate.getTime() + (1 * 24 * 60 * 60 * 1000));
            var expiresText = "; expires=" + cookieDate.toGMTString();
            document.cookie = "CTAName=Community - CTA Community Info" + expiresText + "; path=/; domain=newhomesource.com";

            builderWebsite.addEventToElement("click", function () { logger.logEventWithParameters("BUILDCD", logParams); });
        }

        setTimeout(logCommunityDetail, 1000);
    }());

    (function () {
        var toggleReadMore = function (element) {
            var content = element.parentElement.getElementsByClassName("nhs_SeoDescription")[0];
            var arrow = element.parentElement.getElementsByClassName("nhs_readMoreLink")[0];

            if ("undefined" !== typeof content && content !== null) {
                if (content.classList.contains("closed")) {
                    content.classList.remove("closed");
                    arrow.classList.add("open");
                    element.innerHTML = language.readLess + "<i class='material-icons collapsibleArrow'>keyboard_arrow_down</i>";
                } else {
                    content.classList.add("closed");
                    arrow.classList.remove("open");
                    element.innerHTML = language.readMore + "<i class='material-icons collapsibleArrow'>keyboard_arrow_down</i>";
                }
            }
        };

        var readMoreLinks = document.getElementsByClassName("nhs_readMoreLink");

        for (var i = 0; i < readMoreLinks.length; i += 1) {
            readMoreLinks[i].addEventListener("touchend", function (event) {
                toggleReadMore(this);
                event.preventDefault();
                event.stopPropagation();
            });
        }

        return false;
    }());

    var mainDetailImage = document.querySelector("[data-mainImage]");
    if (mainDetailImage) {
        mainDetailImage.onerror = function() {
             mainDetailImage.src = routes.noPhotoListing;
        }
    };

});
define("pwa/pages/CommunityDetail/showInactiveCommunity", function(){});

